const validTheme = hue => {
  return hue && isNumber(hue) && correctRange(hue, 360)
}

const isNumber = val => /^\d+$/.test(val)

const correctRange = (val, max) => val >= 0 && val <= max

export { validTheme }
